module.exports = __webpack_public_path__ + "img/classImg_no.302a4081.png";